export interface ReportViewProps {
  inspectionId: string
  inspectionName: string
  inspection: Record<string, unknown>
  floors: Record<string, unknown>[]
  onActionsReady?: (actions: {
    onSave?: () => void
    onSignOff?: () => void
    onExport?: () => void
    isSaving?: boolean
    isExporting?: boolean
  }) => void
}

export function statusInfo(s: string): { label: string; color: string; bg: string } {
  const key = s?.toLowerCase() || ''
  if (key === 'done' || key === 'pass') return { label: 'PASS', color: 'text-emerald-700', bg: 'bg-emerald-50 border-emerald-200' }
  if (key === 'further_action' || key === 'f/a') return { label: 'F A', color: 'text-orange-700', bg: 'bg-orange-50 border-orange-200' }
  if (key === 'failed') return { label: 'FAIL', color: 'text-red-700', bg: 'bg-red-50 border-red-200' }
  if (key === 'in_progress') return { label: 'IN PROGRESS', color: 'text-blue-700', bg: 'bg-blue-50 border-blue-200' }
  if (key === 'not_applicable') return { label: 'N/A', color: 'text-slate-500', bg: 'bg-slate-50 border-slate-200' }
  return { label: 'PENDING', color: 'text-slate-500', bg: 'bg-slate-50 border-slate-200' }
}
